import { useApiQuery } from "app/modules/api-client";
import { chosenSites } from "app/common/services/chosenSites";
import { useDisplayAdvertiserPublisherDataAndParams } from "app/pages/digital-marketing/ad-intelligence/common/hooks/useDisplayAdvertiserPublisherDataAndParams";
import DurationService, { BasicDurations } from "app/services/DurationService";

export const useAdModalTable = (creativeId: string, page: number, pageSize: number, advertiserDomain?: string) => {
    const params = useDisplayAdvertiserPublisherDataAndParams();
    const { from, to, isWindow } = DurationService.getDurationData(params.duration).forAPI;
    const primarySite = chosenSites.getPrimarySite();
    // Industry ads belong to an advertiser outside the analyzed site, so the creative's
    // own advertiser is the only key that resolves its publishers.
    const selectedSite = advertiserDomain ?? params.adsSelectedSite ?? primarySite?.name;

    const {
        data: response,
        isLoading,
        isError,
    } = useApiQuery(
        {
            tag: "AdIntelligenceMarketingAssets",
            methodName: "v2AdIntelligenceAdvertiserAdsGalleryUnifiedPublishersList",
            options: {
                enabled: !!creativeId && Boolean(selectedSite),
                select: (publishersResponse) => {
                    if (!publishersResponse) {
                        return;
                    }
                    return {
                        items:
                            publishersResponse.data?.map((item) => ({
                                domain: { name: item.entity, favicon: item.favicon },
                                screenshot: { link: item.imageUrl, siteName: item.entity },
                            })) ?? [],
                        totalCount: publishersResponse.totalCount,
                    };
                },
            },
        },
        {
            creativeUuid: creativeId,
            key: [selectedSite],
            country: params.country,
            page,
            pageSize,
            from,
            to,
            isWindow,
            ...(isWindow ? { latest: BasicDurations.LAST_TWENTY_EIGHT_DAYS } : {}),
        },
    );

    return {
        ...(!isError && { data: response }),
        isLoading,
        isError,
    };
};
